export enum KeyCode {
  Tab = 9,
  Enter = 13,
  Shift = 16,
  Escape = 27,
  Space = 32,
  End = 35,
  Home = 36,
  UpArrow = 38,
  DownArrow = 40,
  RightArrow = 39,
  LeftArrow = 37,
}

export const TAB_KEY = KeyCode.Tab;
export const ENTER_KEY = KeyCode.Enter;
export const SHIFT_KEY = KeyCode.Shift;
export const ESCAPE_KEY = KeyCode.Escape;
export const SPACE_KEY = KeyCode.Space;
export const END = KeyCode.End;
export const HOME = KeyCode.Home;
export const UP_ARROW = KeyCode.UpArrow;
export const DOWN_ARROW = KeyCode.DownArrow;
export const RIGHT_ARROW = KeyCode.RightArrow;
export const LEFT_ARROW = KeyCode.LeftArrow;

/**
 * Supported keyboard values of the `KeyboardEvent` interface's `key` property.
 * More `key` values can be added as they become needed for features or for refactoring to move away from using `keyCode` values.
 *
 * @note Opt for building future features relying on `KeyboardEvent` using `key` rather than `keyCode`, as the latter is deprecated. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 */
export enum Key {
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SHIFT = 'Shift',
  SPACE = ' ',
  TAB = 'Tab',
}
